var map = {
	"./additional_insurance.svg": "6fc5",
	"./additional_insurance_cap.svg": "66c1",
	"./additional_secure_activation.svg": "3ba6",
	"./buttonComparatorIcon.svg": "eeba",
	"./check_circle.svg": "2716",
	"./collection_cycle.svg": "3df8",
	"./coverage_population.svg": "fbdc",
	"./cross_circle.svg": "1da9",
	"./cut_schedule.svg": "4d5d",
	"./deductible_indemnities.svg": "5b96",
	"./delivery_attempts.svg": "ddb8",
	"./delivery_creation_info.svg": "487d",
	"./deposit_in_account.svg": "2489",
	"./failed_collections.svg": "ff58",
	"./icon-hand-right.svg": "5532",
	"./independent_compensation_collection_accepted.svg": "0141",
	"./insurance_included.svg": "5c10",
	"./insurance_percentage.svg": "84d0",
	"./insurance_value.svg": "4348",
	"./max_packages.svg": "0ba7",
	"./max_packages_boolean.svg": "4c9e",
	"./maximum_number_of_packages.svg": "0a32",
	"./min_pickup.svg": "6141",
	"./observations.svg": "d968",
	"./other_charges.svg": "dc3d",
	"./package_size.svg": "07d3",
	"./pickup_point.svg": "322d",
	"./pickup_schedule.svg": "03cf",
	"./pickup_summary.svg": "06ac",
	"./reexpeditions.svg": "e97b",
	"./returns.svg": "a0d3",
	"./scheduling.svg": "d2e3",
	"./scheduling_type.svg": "a87e",
	"./secure_summary.svg": "4e70",
	"./square_to_disavow_delivery.svg": "8278",
	"./summary.svg": "2f20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f627";